import {
  requestGet,
  requestPost,
  requestDelete,
  requestPut,
} from '../utils/request';
import { shouldUseMockWithoutSeasonData } from '../utils/mocks';

export const ROOT_URL = '';
export const BASE_URL = '/api/tenderfoot/v2/activities';
export const TAGS_BASE_URL = '/api/tenderfoot/v2/tags';
export const COMMENTS_BASE_URL = '/comments';

/**
 * Get activities
 * @param {String | String[]} field
 * @return {Promise} Response
 */
export function requestActivities(field) {
  // We can send one field, a list of fields or not fields at all
  const fields = Array.isArray(field) ? field.join(',') : [field];

  const mockFile = shouldUseMockWithoutSeasonData()
    ? 'activities/noData'
    : 'activities/default';

  return requestGet(`${BASE_URL}?fields=${fields}&includeFieldNotes=true`, {
    mockFile,
    rootUrl: ROOT_URL,
  });
}

/**
 * Create a new Activity with optional Comments and Tags
 * @param {Object} activity
 * @param {string} [activity.color]
 * @param {Object[]} [activity.comments]
 * @param {string} activity.comments.note
 * @param {Object} activity.comments.location
 * @param {string} activity.field
 * @param {Object} activity.location
 * @param {boolean} activity.permanent
 * @param {string} [activity.scoutedAt]
 * @param {string[]} [activity.tags]
 * @param {string} [activity.title]
 * @return {Promise<Object>} Response
 */
export function sendActivity(activity) {
  // We can send one field, a list of fields or not fields at all

  return requestPost(`${BASE_URL}`, { data: activity, rootUrl: ROOT_URL });
}

/**
 * Add a new asset to an activity
 * @param {Object} asset
 * @param {String} activityId
 * @return {Promise} Response
 */
export function sendAsset(asset, activityId) {
  const formData = new FormData();
  if (Array.isArray(asset)) {
    asset.forEach(image => {
      formData.append('file', image);
    })
  } else {
    formData.append('file', asset);
  }
  const url = `${BASE_URL}/${activityId}/assets`;
  const mockFile = 'activities/asset';

  return requestPost(url, {
    data: formData,
    isFormData: true,
    mockFile,
    rootUrl: ROOT_URL,
  });
}

/**
 * Delete and Activity by Id
 * @param {String} activityId
 * @return {Promise<Object>} Response
 */
export function deleteActivity(activityId) {
  return requestDelete(`${BASE_URL}/${activityId}`, { rootUrl: ROOT_URL });
}

/**
 * Get tags
 * @param {String} userId
 * @return {Promise} Response
 */
export function requestTags(userId) {
  const headers = {
    'X-User-Id': userId,
  };
  return requestGet(TAGS_BASE_URL, { rootUrl: ROOT_URL, headers });
}

/**
 * Update an Activity with optional Comments and Tags
 * @param {Object} activity
 * @param {string} [activity.color]
 * @param {Object[]} [activity.comments]
 * @param {string} activity.comments.note
 * @param {Object} activity.comments.location
 * @param {string} activity.field
 * @param {Object} activity.location
 * @param {boolean} activity.permanent
 * @param {string} [activity.scoutedAt]
 * @param {string[]} [activity.tags]
 * @param {string} [activity.title]
 * @return {Promise<Object>} Response
 */
export function updateActivity(activity) {
  return requestPut(`${BASE_URL}/${activity.id}`, {
    data: activity,
    rootUrl: ROOT_URL,
  });
}

export function updateComments(activityId, comment) {
  return requestPut(
    `${BASE_URL}/${activityId}${COMMENTS_BASE_URL}/${comment.id}`,
    {
      data: comment,
      rootUrl: ROOT_URL,
    }
  );
}

/** Add a new asset to an activity
 * @param {String} activityId
 * @param {String} assetId
 * @param {String} userId
 * @return {Promise} Response
 */
export function deleteAsset(activityId, assetId, userId) {
  const url = `${BASE_URL}/${activityId}/assets/${assetId}`;
  const headers = {
    'X-User-Id': userId,
  };
  return requestDelete(url, { rootUrl: ROOT_URL, headers });
}
